import React, { type PropsWithChildren } from "react"
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { store, persistor, apolloClient } from './Store'

import { Client as Styletron } from "styletron-engine-monolithic"
import { Provider as StyletronProvider } from "styletron-react"


import "./Assets/Fonts/fonts.css"
import { colors } from "./Styles/index"

import { CookieModal } from "./Components"

import "./Styles/reset.css"


/* TODO: ApolloConnectors Should only be initilazed after login is confirmed */
import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client'
import { MainNavigator } from "./Navigation/Routers"

export const IS_CLOUD = process.env.REACT_APP_CLOUD_BUILD ? Boolean(process.env.REACT_APP_CLOUD_BUILD) : false; 

/* interface ExtendedRenderOptions extends Omit<RenderOptions, "queries"> {
  preloadedState?: Partial<RootState>
  store?: AppStore,
  client?: ApolloClient<NormalizedCacheObject>
} */

//import { Suspense } from 'react'
//App.logout().then(() => client.resetStore());   //clearStore

//const origin = process.env.REACT_APP_GRAPHQL_ADDRESS ? process.env.REACT_APP_GRAPHQL_ADDRESS: `${window.location.protocol}//${window.location.hostname}:${process.env.REACT_APP_GRAPHQL_PORT ?? "4000"}` 

const Wrapper = ({ children }:PropsWithChildren, store:any, client:ApolloClient<NormalizedCacheObject>) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <StyletronProvider value={new Styletron()}>
        {/* <BaseProvider
          theme={DarkTheme}
          zIndex={999}
          overrides={{
            AppContainer:{
              style: () => ({
                outline: `0px #000 solid`,
                backgroundColor: colors.greyDarkSecondary, 
                position: 'absolute',
                top: 0, left: 0, bottom: 0, right: 0,
                height: '100%', width: '100%', default: {height: '100%', width: '100%'},
                overflow: "hidden"
              })
            },
          }}> */}
          <ApolloProvider client={client} >
            {children}
            <CookieModal/>
          </ApolloProvider>
        {/* </BaseProvider> */}
      </StyletronProvider>
    </PersistGate>
  </Provider>
)

/* export function renderWithProviders( ui: React.ReactElement, extendedRenderOptions: ExtendedRenderOptions = {}) {
  const {
    preloadedState = {},
    // Automatically create a store instance if no store was passed in
    store = setupStore(preloadedState),
    client = setupApolloClient(),
    ...renderOptions
  } = extendedRenderOptions

  // Return an object with the store and all of RTL's query functions
  return { 
    store, client, 
    ...render(ui, { wrapper: (e) => Wrapper(e, store, client), ...renderOptions }) 
  }
} */


export function AgrisysApp():JSX.Element {
  return Wrapper({children:<MainNavigator/>}, store, apolloClient)
}
